import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3245 2.09034C14.4546 2.16795 14.5568 2.29003 14.6146 2.43709C14.6724 2.58416 14.6826 2.74774 14.6436 2.90174L12.8729 9.85674H19.3334C19.4633 9.85675 19.5904 9.89743 19.699 9.97378C19.8076 10.0501 19.8931 10.1588 19.9448 10.2865C19.9966 10.4142 20.0124 10.5553 19.9903 10.6925C19.9682 10.8296 19.9092 10.9569 19.8205 11.0586L10.4871 21.7725C10.3854 21.8895 10.2501 21.9665 10.1028 21.9913C9.95542 22.0162 9.80456 21.9873 9.67431 21.9094C9.54407 21.8315 9.44197 21.7091 9.38434 21.5617C9.32671 21.4143 9.31688 21.2505 9.35643 21.0964L11.1271 14.1423H4.66663C4.53671 14.1423 4.40962 14.1016 4.30099 14.0253C4.19235 13.9489 4.10691 13.8402 4.05516 13.7125C4.00342 13.5849 3.98762 13.4438 4.00971 13.3066C4.0318 13.1694 4.09082 13.0422 4.17951 12.9404L13.5129 2.22652C13.6146 2.11 13.7497 2.03329 13.8968 2.0086C14.0439 1.98392 14.1944 2.0127 14.3245 2.09034Z"
        fill={colorValue}
      />
    </svg>
  );
};
